import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/rexue', label: '排行榜' },
    { to: '/category/lianai', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-200))]' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-50 tracking-wider">
              虚空韩漫网
            </span>
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-light tracking-wide whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.to
                    ? 'text-foreground-50'
                    : 'text-foreground-500 hover:text-foreground-200'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-5 py-2 text-sm font-medium text-foreground-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer">
              登录 / 注册
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm py-2 transition-colors duration-200 ${
                  location.pathname === link.to
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-400 hover:text-foreground-200'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button className="mt-2 px-5 py-2.5 text-sm font-medium text-foreground-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors duration-200 text-center whitespace-nowrap cursor-pointer">
              登录 / 注册
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}